export default "__VITE_ASSET__B1IM0Nbx__"